import React from 'react';
import classes from './headlight.css';

export default ({ style, children }) => (
    <div className={classes.headlightWrapper} style={style}>
        {children}
    </div>
);
